export default __webpack_public_path__ + "static/media/six.01d68092.jpg";